import axios from "axios";
import React, { useEffect, useState } from "react";
import dollarSold from "../../../../../../../assets/images/dollarSign-removebg-preview.png";
// import MarketPlaceNav from '../../../../MarketPlaceNav';
// import something from '../../../../../../assets/images/footBallJersey.jpg'
import LiveIcon from "../../../../../../../assets/images/Souvenir/live.png";
import Unsold from "../../../../../../../assets/images/Souvenir/packages.png";
import tagPrice from "../../../../../../../assets/images/tagPrice.PNG";
import MarketPlaceNav from "../MarketPlaceNav/MarketPlaceNav";
import Nodata from "../../../../../../../assets/Icon/Nodata.png";
import "./MarketPlace.css";
// import MarketPlaceNav from '../MarketPlaceNav/MarketPlaceNav';
import moment from "moment";
import AllDataHeader from "../../../../../../Reuseable/AllDataHeader";
import LoaderPost from "../../../../../../Reuseable/LoaderPost";
import { serverInfo } from "../../../../../../../App";
import { useContext } from "react";

const MarketPlaceSouvenir = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [liveProduct, setLiveProduct] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    axios.get(`/api/admin/marketplace/product-list/live`).then((res) => {
      setLoading(false);
      if (res.status === 200) {
        setLiveProduct(res.data.live);
      }
    });
  }, []);
  return (
    <>
      <div className="AS m-3">
        <MarketPlaceNav />

        <div className="d-flex mb-4 my-4 card-bg head-line p-3 justify-content-center align-items-center">
          <div className=" d-flex">
            <img src={LiveIcon} className=" SouvenirIcon" alt="" />
          </div>

          <div className=" d-flex text-light fw-bold mt-1 mx-3 ">Live Now</div>
        </div>

        {loading === true ? (
          <LoaderPost />
        ) : (
          <>
            {liveProduct.length !== 0 ? (
              <div className="row">
                {liveProduct.map((live, index) => (
                  <div className="col-md-6 my-1">
                    <div className="row Souvenir-LiveM ">
                      <div className="col-md-5 p-0">
                        <img
                          src={imageCdnUrl + live.image}
                          className="footBallJerseyImageM img-fluid"
                          alt=""
                        />
                      </div>
                      <div className="col-md-7 py-3 px-0">
                        <div className="SouvenirI d-flex justify-content-center mx-4">
                          <div className="d-flex justify-content-center align-items-center">
                            <div>
                              <div>
                                <div className="mb-4">
                                  <div className="text-light fw-bold mt-1 mx-2">
                                    <h5 className="marketPlaceTitle">
                                      {live.title}
                                    </h5>
                                  </div>
                                  <div className="text-light  mt-1 mx-2 ">
                                    <small>
                                      Started{" "}
                                      <span className=" ms-2 text-info fw-bold">
                                        {moment(live.created_at).format("LL")} -{" "}
                                        {moment(live.created_at).format("LT")}
                                      </span>
                                    </small>
                                  </div>
                                </div>

                                <div className="d-flex  p-2 mb-2">
                                  <img
                                    src={tagPrice}
                                    className=" SouvenirIcon"
                                    alt=""
                                  />

                                  <div className=" d-flex text-light  mt-1 mx-3 fw-bold ">
                                    <span className="text-success fw-bold">
                                      {live.unit_price}{" "}
                                    </span>
                                    <span className="ms-3 fw-bold">/</span>{" "}
                                    <span className="unitFontText ms-3 mt-2">
                                      unit
                                    </span>
                                  </div>
                                </div>

                                <div>
                                  <div className="d-flex">
                                    <div className="bg-dark borderTotalSold px-4 py-3 rounded">
                                      <small className="text-primary fw-bold">
                                        Total
                                      </small>
                                      <div className="d-flex mt-2">
                                        <img
                                          src={Unsold}
                                          className="img-fluid imgTab"
                                          width="30px"
                                          alt=""
                                        />
                                        <h4 className="ms-3 text-white smallTxt fw-bold">
                                          {live.total_items}
                                        </h4>
                                      </div>
                                    </div>
                                    <div className="bg-dark borderTotalSold ms-3 px-4 py-3 rounded">
                                      <small className="text-primary fw-bold">
                                        Sold
                                      </small>
                                      <div className="d-flex mt-2">
                                        <img
                                          src={dollarSold}
                                          className="img-fluid imgTab"
                                          width="40px"
                                          alt=""
                                        />
                                        <h4 className="ms-3 text-white smallTxt fw-bold">
                                          {live.total_selling}
                                        </h4>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <>
                {" "}
                <div className="row justify-content-center align-items-center">
                  <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
                    <img src={Nodata} alt="" className=" Nodata" />
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default MarketPlaceSouvenir;
